/* eslint-disable react/no-unescaped-entities */

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  HStack,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import { AboutData, AboutDataKeys } from '../components/about/data';
import Footer from '../components/footer/Footer';
import Navbar from '../components/navbar';
import SeoHead from '../components/common/SeoHead';
import JsonLd from '../components/common/JsonLd';

/* eslint-disable @next/next/no-img-element */

const aboutOrgSchema = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'Vital Educators',
  url:
    process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, '') ||
    'https://vitaleducators.com',
  logo: `${(
    process.env.NEXT_PUBLIC_SITE_URL || 'https://vitaleducators.com'
  ).replace(/\/$/, '')}/logo-black.png`,
  description:
    'Vital Educators was established to empower young individuals by providing fantastic coaches and tutors, free exam-related content, and a career-based podcast.',
};

const About = () => {
  return (
    <div
      style={{
        overflowX: 'hidden',
      }}
    >
      <SeoHead
        title="About Us | Vital Educators"
        description="Learn about Vital Educators — empowering students with local tutors, free GCSE & A-level resources, and career-focused guidance."
        path="/about"
      />
      <JsonLd schema={aboutOrgSchema as Record<string, unknown>} />
      <Navbar />
      <VStack
        // bg="black"
        minH={'100vh'}
        gap="2em"
        minW="100vw"
        maxW="100vw"
        h="max-content"
        py="5em"
        overflow={'hidden'}
      >
        <VStack
          w={'full'}
          px={['1em', '2em', '4em']}
          gap="3em"
          maxW="100vw"
          overflow="hidden"
        >
          <VStack
            gap="2em"
            alignItems={'flex-start'}
            w="full"
            flexDir={['column', 'column', 'row']}
            as={HStack}
          >
            <VStack alignItems={'flex-start'} flex="1">
              <Text fontWeight={'extrabold'} borderBottom="1px solid black">
                About Us
              </Text>
              <Text as="h1" fontSize={['1.4em', '1.8em', '2em']} fontWeight="extrabold">
                Welcome to Vital Educators
              </Text>
              <Text fontSize={'.9em'} color="#505050">
                Vital Educators was built to give every UK student access to the
                right tutor — regardless of subject, level, or location. We
                connect students with verified, expert tutors for GCSE, A-Level,
                and primary education, both online and in person. Every tutor on
                our platform is manually reviewed and approved before going
                live, so students and parents can search with confidence. We
                also provide free exam resources — revision materials, past
                papers, and study guides — because great education shouldn't
                come with a price tag. Unlike other tutoring platforms, we
                charge tutors zero commission. Every penny they earn, they keep!
              </Text>
            </VStack>
            <Image
              src="/logo-black.png"
              alt="Vital Educators logo"
              maxW={['100%', '100%', '400px']}
              objectFit="cover"
            />
          </VStack>
          {Object.keys(AboutData).map((key, idx) => (
            <VStack w="full" alignItems={'flex-start'} key={idx}>
              <Text fontSize="1.2em" fontWeight={'extrabold'}>
                {key.toUpperCase()}
              </Text>
              <Accordion allowMultiple w="full">
                {AboutData[key as AboutDataKeys].map((item, idx) => (
                  <AccordionItem key={idx}>
                    <h2>
                      <AccordionButton borderLeft={'2px solid blue'}>
                        <Box flex="1" textAlign="left">
                          {item.title}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>{item.content}</AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </VStack>
          ))}
        </VStack>
      </VStack>
      <Footer />
    </div>
  );
};

export default About;
